export default __webpack_public_path__ + "static/Group-148806-b2046a17ae8e7c4c3998386b111b239d.png";